@if (brand == 'prixtel') {
  <app-vitrine-menu></app-vitrine-menu>
}
@if (brand == 'coriolis') {
  <app-vitrine-menu-coriolis></app-vitrine-menu-coriolis>
}

<div [id]="'wrapper-' + brand" class="wpx_wrap">
  @if (brand == 'lacarte') {
    <a href="{{ vitrineUrl }}" class="logo"></a>
  }
  <app-breadcrumb [breadcrumb]="breadcrumbDetails" [brand]="brand"></app-breadcrumb>
</div>

<div [id]="'login-form-' + brand" class="row form_container">
  <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
    <div class="card card-signin my-5">
      <div class="card-body text-center">
        <h1 class="card-title text-center blue-color">Réinitialiser le mot de passe</h1>
        @if (resetPasswordForm) {
          <form class="form" [formGroup]="resetPasswordForm" >
            <ul>
              <li class="mb-4">
                <input type="hidden" class="form-control" placeholder="token" formControlName="token">
                <label class="bold-label-text">Nouveau mot de passe*</label>
                <div class="form-group wpx_passWrap">
                  <a href="#" id="togglePass" (click)="togglePasswordService.toggle($event)">Voir</a>
                  <input type="password" class="form-control" placeholder="Nouveau mot de passe" formControlName="newPassword">
                  @if (resetPasswordFormSubmitted && resetPasswordForm.controls.newPassword.errors) {
                    <p class="error-message">{{ getError('newPassword') }}</p>
                  }
                </div>
              </li>
              <li>
                <label class="bold-label-text">Confirmation nouveau mot de passe*</label>
                <div class="form-group wpx_passWrap">
                  <a href="#" id="togglePass2" (click)="togglePasswordService.toggle($event)">Voir</a>
                  <input type="password" class="form-control" placeholder="Confirmation nouveau mot de passe" formControlName="confirmationNewPassword">
                  @if (resetPasswordFormSubmitted && resetPasswordForm.controls.confirmationNewPassword.errors) {
                    <p class="error-message">{{ getError('confirmationNewPassword') }}</p>
                  }
                </div>
              </li>
            </ul>
            <re-captcha #captcha="reCaptcha" (resolved)="resolved($event)" size="invisible" [siteKey]="captchaKey" (error)="errored(captcha)" errorMode="handled"></re-captcha>
            <div class="bloc_cta">
              <button type="submit" class="cta_btn level_2" (click)="onLoginClick(captcha)">Enregistrer<span></span></button>
              <button class="cta_cancel" (click)="backToLoginPage()">Annuler<span></span></button>
            </div>
          </form>
        }
        @if (errorMessage !== null) {
          <div class="error-message text-center">{{ errorMessage }}</div>
        }
      </div>
    </div>
  </div>
</div>

@if (brand == 'prixtel') {
  <app-vitrine-footer></app-vitrine-footer>
}
@if (brand == 'coriolis') {
  <app-vitrine-footer-coriolis></app-vitrine-footer-coriolis>
}
